import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import classnames from 'classnames';
import React, { useContext } from 'react';
import { useDeepEqualMemo } from './hooks/useDeepEqualMemo';
import { ThemeOptions, ThemeSurface } from './constants';
export function getGlobalClassnamesForContext({ isMobile, theme, isSisu, flags = {}, themeSkin, themeSurface = ThemeSurface.PRIMARY, isLoggedIn }) {
    return classnames(isMobile && 'mobile', !isSisu && `theme-${(theme || ThemeOptions.DARK).toString()}`, isSisu && 'sisu', themeSkin, 'surface', themeSurface, flags['status_font_sizes'] && 'status_font_sizes');
}
export function getForcedGlobalClassnamesForContext({ theme, themeSkin, themeSurface, flags = {} }) {
    return classnames(`theme-${theme}`, `forced-theme-${theme}`, themeSkin, 'surface', themeSurface);
}
export function getComponentName(Component) {
    return Component.displayName || Component.name || 'Component';
}
// Helper to create a context provider component that instead of replacing
// parent values, it merges them with the provided ones
export function createMergingContextProvider(context, displayName = `${context.displayName || 'Context'}Provider`) {
    const MergingContextProvider = ({ children, value })=>{
        const parentContext = useContext(context);
        const merged = useDeepEqualMemo(_object_spread({}, parentContext, value));
        return /*#__PURE__*/ React.createElement(context.Provider, {
            value: merged
        }, children);
    };
    MergingContextProvider.displayName = displayName;
    return MergingContextProvider;
}
